import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import cacheManager from '../CacheManager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faPen, faKey } from '@fortawesome/free-solid-svg-icons';

const PgClientes = () => {
  const [clientes, setClientes] = useState([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const clientesPorPagina = 10;
  const [termoDeBusca, setTermoDeBusca] = useState('');
  const [clientesFiltrados, setClientesFiltrados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const search = async () => {
    try {
      setIsLoading(true);
      const clientesCache = await cacheManager.getClientesCache()
      setClientes(clientesCache);
    } catch (error) {
      console.error('Erro ao buscar clientes:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Estilos para esmaecer a página
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 2, // Garanta que esteja acima de outros elementos da página
    display: isLoading ? 'block' : 'none', // Mostra apenas quando está carregando
};

  useEffect(() => {
    search(); // Chama a função search ao montar o componente
  }, []); // O array vazio como segundo argumento garante que o efeito seja executado apenas uma vez, na montagem do componente

  useEffect(() => {
    const clientesOrdenados = [...clientes].sort((a, b) => {
      const nomeA = a.nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      const nomeB = b.nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

      return nomeA.localeCompare(nomeB, 'pt-BR', { sensitivity: 'base' });
    });

    const clientesFiltrados = clientesOrdenados.filter(cliente => {
      const nomeCliente = cliente.nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      return nomeCliente.includes(termoDeBusca.toLowerCase());
    });

    setClientesFiltrados(clientesFiltrados);
    setPaginaAtual(1);
  }, [clientes, termoDeBusca]);

  const addCustomer = () => {
    navigate('/cliente/novo'); // Use navigate para ir para /cliente/novo
  };

  // Calcular o número total de páginas
  const totalPaginas = Math.ceil(clientesFiltrados.length / clientesPorPagina);

  // Obter os clientes da página atual
  const indexDoUltimoCliente = paginaAtual * clientesPorPagina;
  const indexDoPrimeiroCliente = indexDoUltimoCliente - clientesPorPagina;
  const clientesAtuais = clientesFiltrados.slice(indexDoPrimeiroCliente, indexDoUltimoCliente);

  // Funções para alterar a página
  const irParaPagina = (numero) => {
    setPaginaAtual(numero);
  };


  return (
    <div className="container mt-5">
      {isLoading && <div style={overlayStyle}></div>} {/* Overlay de carregamento */}
      <h2 className="mb-4">Clientes</h2>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar..."
          id="search-input"
          value={termoDeBusca}
          onChange={(e) => setTermoDeBusca(e.target.value)}
        />
        <button className="btn btn-outline-secondary" type="button" onClick={search}>Buscar</button>
      </div>
      <table className="table">
        <thead className="table-light">
          <tr>
            <th>Nome</th>
            <th>CPF</th>
            <th>Telefone</th>
            <th>Email</th>
            <th>Nascimento</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {clientesAtuais.map((cliente, index) => (
            <tr key={index}>
              <td>
                <Link to={`/cliente/editar/${cliente.id_cliente}`} className="text-dark underline-on-hover">
                {cliente.nome}
                {cliente.contrato_data_assinatura && <FontAwesomeIcon icon={faPen} className="ms-2" style={{ color: 'darkgreen' }} />}
                {cliente.possuiSenha && <FontAwesomeIcon icon={faKey} className="ms-2" style={{ color: 'darkblue' }} />}
                </Link>
              </td>
              <td>{cliente.cpf}</td>
              <td>{cliente.telefone}</td>
              <td>{cliente.email}</td>
              <td>{cliente.nascimento ? new Date(cliente.nascimento).toLocaleDateString('pt-BR') : ''}</td>
              <td>
                <Link to={`/cliente/editar/${cliente.id_cliente}`} className="btn btn-primary btn-sm me-2">
                  <FontAwesomeIcon icon={faEdit} /> Editar
                </Link>
                <button className="btn btn-danger btn-sm" disabled>
                  <FontAwesomeIcon icon={faTrash} /> Excluir
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          {/* Conteúdo da paginação */}
          <button onClick={() => irParaPagina(1)} disabled={paginaAtual === 1} className="btn btn-secondary" style={{ fontSize: '10px' }}>
            Primeira
          </button>
          {paginaAtual > 2 && (
            <button onClick={() => irParaPagina(paginaAtual - 2)} className="btn btn-secondary" style={{ fontSize: '10px' }}>
              {paginaAtual - 2}
            </button>
          )}
          {paginaAtual > 1 && (
            <button onClick={() => irParaPagina(paginaAtual - 1)} className="btn btn-secondary" style={{ fontSize: '10px' }}>
              {paginaAtual - 1}
            </button>
          )}
          <button className="btn btn-primary" style={{ fontSize: '10px' }}>
            {paginaAtual}
          </button>
          {paginaAtual < totalPaginas && (
            <button onClick={() => irParaPagina(paginaAtual + 1)} className="btn btn-secondary" style={{ fontSize: '10px' }}>
              {paginaAtual + 1}
            </button>
          )}
          {paginaAtual < totalPaginas - 1 && (
            <button onClick={() => irParaPagina(paginaAtual + 2)} className="btn btn-secondary" style={{ fontSize: '10px' }}>
              {paginaAtual + 2}
            </button>
          )}
          <button onClick={() => irParaPagina(totalPaginas)} disabled={paginaAtual === totalPaginas} className="btn btn-secondary" style={{ fontSize: '10px' }}>
            Última
          </button>
        </div>
        <div>
          {/* Botão Incluir */}
          <button type="button" className="btn btn-primary" onClick={addCustomer}>Incluir</button>
        </div>
      </div>
    </div>
  );
};

export default PgClientes;